module.exports = __webpack_public_path__ + "static/media/UCI_logo_color.3be42697.png";